import React from "react";
import Webcam from "react-webcam";
import "./PersonalDataUpdateOcrWebcam.css";

const videoConstraints = {
  width: { min: 310, ideal: 1920, max: 1920 },
  height: { min: 174, ideal: 1080 },
  aspectRatio: 1.777777778,
  facingMode: "environment",
};

const PersonalDataUpdateOcrWebcam = React.forwardRef(
  ({ capturedImage }, ref) => {
    return (
      <div className="webcam-preview-container mb-3">
        <div className="webcam-rectangle">
          {!capturedImage && (
            <Webcam
              audio={false}
              ref={ref}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              width="310px"
              height="174px"
              forceScreenshotSourceSize="true"
            />
          )}
          {capturedImage && (
            <img
              src={capturedImage}
              alt="captured id card"
              className="preview-image"
            />
          )}
        </div>
      </div>
    );
  }
);
export default PersonalDataUpdateOcrWebcam;
